import { Fragment, useState } from "react";
import OpenFormButton from "./OpenFormButton";
import FeedbackFormModal from "./FeedbackFormModal";
import { sendFeedbackSnetAPI } from "../../Services/FeedbackApi/SupportAPI";
import "./styles.css";

const FeedbackFormContainer = () => {
    const [isModalVisible, setIsModalVisible] = useState(false);

    return (
        <Fragment>
            <div id="captchaContainer" />
            <FeedbackFormModal
                sendFeedbackAPI={sendFeedbackSnetAPI}
                isModalVisible={isModalVisible}
                setIsModalVisible={setIsModalVisible}
            />
            <OpenFormButton openForm={() => setIsModalVisible(true)} />
        </Fragment>
    );
};

export default FeedbackFormContainer;
